import EmptyCircleImg from "@/assets/empty/empty-circle.png";
import EmptyConnectionImg from "@/assets/empty/empty-connection.png";
import EmptyTeaImg from "@/assets/empty/empty-tea.png";
import EmptyEndorsementImg from "@/assets/empty/empty-endorsement.png";
import EmptyEventImg from "@/assets/empty/empty-event.png";
import EmptyGoalsImg from "@/assets/empty/empty-goals-mentor-mentee.png";
import EmptyUserGuideImg from "@/assets/empty/empty-user-guide.png";

import { PAGE_URL } from "@/utils/constants";

export const emptyWordingData = {
  dashboard: {
    endorsement: {
      title: "Earn more points by writing endorsements for your colleagues!",
      cta_title: "Write Endorsement",
      cta_link: PAGE_URL.connections,
      shallow: false,
      body: null,
      emptyIcon: EmptyEndorsementImg,
    },
    recommendedCircle: {
      title: "Earn points by joining a circle!",
      cta_title: "Join a Circle",
      cta_link: PAGE_URL.mycalendar,
      shallow: false,
      body: null,
      emptyIcon: EmptyCircleImg,
    },
    recommendedEvent: {
      title: "Earn points by joining an event!",
      cta_title: "Join an Event",
      cta_link: PAGE_URL.mycalendar,
      shallow: false,
      body: null,
      emptyIcon: EmptyEventImg,
    },
    recommendedConnection: {
      title: "Earn points by finding a connection!",
      cta_title: "Find a Connection",
      cta_link: PAGE_URL.connections,
      shallow: false,
      body: null,
      emptyIcon: EmptyConnectionImg,
    },
  },
  myCalendar: {
    recommended: {
      events: {
        title: "Earn points by joining an event!",
        cta_title: null,
        cta_link: null,
        shallow: null,
        body: null,
        emptyIcon: EmptyEventImg,
      },
      circles: {
        title: "Earn points by joining a circle!",
        cta_title: null,
        cta_link: null,
        shallow: null,
        body: null,
        emptyIcon: EmptyCircleImg,
      },
    },
  },
  notification: {
    invitationEndorsements: {
      circle: {
        title:
          "Earn points by introducing circles to colleagues and by accepting invitations to circles!",
        body: null,
        cta_title: "Introduce a Circle",
        cta_link: PAGE_URL.circles,
        shallow: false,
      },
      events: {
        title:
          "Earn points by introducing events to colleagues and by accepting invitations to events!",
        body: null,
        cta_title: "Introduce an Event",
        cta_link: PAGE_URL.events,
        shallow: false,
      },
      endorsements: {
        title:
          "Earn points by endorsing colleagues and by accepting endorsements!",
        body: null,
        cta_title: "Endorse",
        cta_link: PAGE_URL.connections,
        shallow: false,
      },
      connections: {
        title:
          "Earn points by sending connection requests to colleagues and by accepting connection requests!",
        body: null,
        cta_title: "Create Mentorship",
        cta_link: PAGE_URL.connections,
        shallow: false,
      },
      circleofChampion: {
        title:
          "Earn lots of points by inviting up to 6 colleagues to your Circle of Champions and by accepting Circle of Champion invitations!",
        body: null,
        cta_title: "Invite to Circle of Champions",
        cta_link: PAGE_URL.connections,
        shallow: false,
      },
      relationshipUpgrades: {
        title:
          "Earn points by upgrading your relationships with colleagues to mentorships!",
        body: null,
        cta_title: "Upgrade Relationship",
        cta_link: PAGE_URL.connections,
        shallow: false,
      },
    },
    recommendedResources: {
      circle: {
        title:
          "Earn points by recommending circles to colleagues and by accepting circle recommendations! ",
        body: null,
        cta_title: "Recommend a Circle",
        cta_link: PAGE_URL.circles,
        shallow: false,
      },
      events: {
        title:
          "Earn points by recommending events to colleagues and by accepting event recommendations!",
        body: null,
        cta_title: "Recommend an Event",
        cta_link: PAGE_URL.events,
        shallow: false,
      },
      connections: {
        title:
          "Earn points by recommending connections to colleagues and by accepting connection recommendations!",
        body: null,
        cta_title: "Recommend a Connection",
        cta_link: PAGE_URL.connections,
        shallow: false,
      },
    },
    skillVerificationRequest: {
      title:
        "Earn points today by submitting skill verification requests or by requesting performance reviews for your completed milestones! Remind your Mentors and Sponsors that they also receive points when they verify your skills or complete your performance review.",
      body: null,
      cta_title: "Request Skill Verification",
      cta_link: PAGE_URL.goals,
      shallow: false,
    },
    skillRecommendations: {
      title:
        "Earn points by recommending skills to your mentees and by accepting skill recommendations!",
      body: null,
      cta_title: "Recommend Skill",
      cta_link: PAGE_URL.connections,
      shallow: false,
    },
  },
  myConnection: {
    recommedation: {
      title: "Your recommended connections are loading.",
      cta_title: null,
      cta_link: null,
      shallow: false,
      body: null,
      emptyIcon: EmptyConnectionImg,
    },
    allConnections: {
      title: "Earn points by making connections with any recommended profile! ",
      cta_title: "Find a Connection",
      cta_link: () => window.scrollTo({ top: 0, behavior: "smooth" }),
      shallow: false,
      body: null,
      emptyIcon: EmptyConnectionImg,
    },
    waves: {
      title:
        "Earn points by waving at any recommended profile and then become Connections!",
      cta_title: "Wave",
      cta_link: () => window.scrollTo({ top: 0, behavior: "smooth" }),
      shallow: false,
      body: null,
    },
    circleOfChamion: {
      body: null,
      title:
        "Earn lots of points by inviting up to 6 colleagues to your Circle of Champions!",
      cta_title: "Invite to Circle of Champions",
      cta_link: `${PAGE_URL.connections}?open=coc`,
      shallow: false,
      emptyIcon: EmptyConnectionImg,
    },
    sponsors: {
      title:
        "Earn points by clicking the 'Create Mentorship' button on any recommended profile to request your colleagues to become your Sponsors!",
      cta_title: "Create Mentorship",
      cta_link: () => window.scrollTo({ top: 0, behavior: "smooth" }),
      shallow: false,
      body: null,
      emptyIcon: EmptyConnectionImg,
    },
    mentors: {
      title:
        "Earn points by clicking the 'Create Mentorship' button on any recommended profile to request your colleagues to become your Mentors!",
      cta_title: "Create Mentorship",
      cta_link: () => window.scrollTo({ top: 0, behavior: "smooth" }),
      shallow: false,
      body: null,
      emptyIcon: EmptyConnectionImg,
    },
    mentee: {
      title:
        "Earn points by clicking the 'Create Mentorship' button on any recommended profile to request your colleagues to become your Mentees!",
      cta_title: "Create Mentorship",
      cta_link: () => window.scrollTo({ top: 0, behavior: "smooth" }),
      shallow: false,
      body: null,
      emptyIcon: EmptyConnectionImg,
    },
    allies: {
      title:
        "Earn points by Waving and Waving Back on any recommended profile and become Connections!",
      cta_title: "Wave",
      cta_link: () => window.scrollTo({ top: 0, behavior: "smooth" }),
      shallow: false,
      body: null,
      emptyIcon: EmptyConnectionImg,
    },
    theTea: {
      title:
        "No Tea Yet! Once there’s some tea to spill, it’ll show up here. Stay tuned!",
      cta_link: null,
      shallow: false,
      body: null,
      emptyIcon: EmptyTeaImg,
    },
  },
  myCircle: {
    myCircle: {
      body: "Earn points by joining circles or creating one!",
      cta_link: null,
      shallow: false,
      title: null,
    },
    yourInvites: {
      body: "Earn points by recommending circles to your colleagues and by accepting invitations to circles!",
      cta_link: null,
      shallow: false,
      title: null,
    },
    recommend: {
      body: "Earn points by recommending circles to your colleagues and by accepting invitations to circles!",
      cta_link: null,
      shallow: false,
      title: null,
    },
  },
  myEvent: {
    myEvent: {
      body: "Earn points by joining events or creating one!",
      cta_link: null,
      shallow: false,
      title: null,
    },
    yourInvites: {
      body: "Earn points by recommending events to your colleagues and by accepting invitations to events!",
      cta_link: null,
      shallow: false,
      title: null,
    },
    recommend: {
      body: "Earn points by recommending events to your colleagues and by accepting invitations to events!",
      cta_link: null,
      shallow: false,
      title: null,
    },
  },
  myGoals: {
    "mygoals-skill-completed": {
      title:
        "Earn points by completing milestones and then requesting performance reviews/skill verification.",
      body: null,
      cta_link: PAGE_URL.connections,
      shallow: false,
      cta_title: "Request Skill Verification",
      emptyIcon: EmptyGoalsImg,
    },
    "mygoals-skill-active": {
      title: "Earn lots of points by adding and completing milestones.",
      body: null,
      cta_link: null,
      shallow: false,
      cta_title: null,
      emptyIcon: EmptyUserGuideImg,
    },
    "mygoals-skill-active-premium": {
      title: "Earn lots of points by adding and completing milestones.",
      body: null,
      cta_link: null,
      shallow: false,
      cta_title: null,
      emptyIcon: EmptyGoalsImg,
    },
    mentor: {
      title:
        "Earn points by clicking the 'Create Mentorship' button to request your colleagues to become your Mentors!",
      body: null,
      cta_title: "Create Mentorship",
      cta_link: PAGE_URL.connections,
      shallow: false,
      breaklineLength: 150,
      emptyIcon: EmptyCircleImg,
    },
    sponsor: {
      title:
        "Earn points by clicking the 'Create Mentorship' button to request your colleagues to become your Sponsors!",
      body: null,
      cta_title: "Create Mentorship",
      cta_link: PAGE_URL.connections,
      shallow: false,
      breaklineLength: 150,
      emptyIcon: EmptyCircleImg,
    },
    skillVerificationTabMentor: {
      title:
        "Earn points by clicking the 'Create Mentorship' button on any recommended profile to request your colleagues to become your Mentor/Sponsor!",
      body: null,
      cta_title: "Create Mentorship",
      cta_link: PAGE_URL.connections,
      shallow: false,
      breaklineLength: 150,
    },
    skillVerificationTabOther: {
      title:
        "Request your Mentor/Sponsor to be the first one to verify this skill",
      body: null,
      cta_link: null,
      shallow: false,
      cta_title: null,
    },
  },
  employeeGoals: {
    mentor: {
      title: "Recommend a mentor to help them achieve their goals.",
      body: null,
      cta_title: "Recommend a Mentor",
      cta_link: `{{asPath}}?recommend=Mentor`,
      shallow: true,
      breaklineLength: 150,
    },
    sponsor: {
      title: "Recommend a sponsor to help them achieve their goals.",
      body: null,
      cta_title: "Recommend a Sponsor",
      cta_link: `{{asPath}}?recommend=Sponsor`,
      shallow: true,
      breaklineLength: 150,
    },
  },
  modal: {
    optionsFave: {
      title: null,
      body: "You'll see your favorites here after answering Quick Questions related to favorites. Each answer helps build your list and earns you points!",
      cta_title: "Answer Quick Questions",
      cta_link: `${PAGE_URL.dashboard}?quickQuestionReminder=true`,
      shallow: false,
    },
    addSkill: {
      allUsed: {
        title:
          "Congratulations! You've added all available skills. Your profile is now enriched with a diverse range of expertise.",
        body: null,
        cta_title: null,
        cta_link: null,
        shallow: false,
      },
    },
    userguide: {
      title:
        "Earn points by notifying your colleagues about how you are advancing towards your goals via MyConnect.Ai.",
      body: null,
      cta_title: "Create Mentorship",
      cta_link: PAGE_URL.connections,
      shallow: false,
    },
    userguideVerifier: {
      title:
        "Earn points by notifying your colleagues about how you are advancing towards your goals via MyConnect.Ai.",
      body: null,
      cta_title: null,
      cta_link: null,
      shallow: false,
    },
  },
};
